export default __webpack_public_path__ + "static/6-7e577cca2cdaf19d1cb8eaf02f7e3133.png";